import { IMovieActivity } from "src/lib/filmwebid/IMovieActivity";
import { buildUserApiQueryKey, useUserApiQuery } from "src/lib/filmwebid/useUserApiQuery";
import { SetStateAction, useCallback, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { query } from "mssql";

export default function useMovieActivity(edi: string | undefined | null, streamingId: string | number | undefined | null)
	: [activity: IMovieActivity | null, updater: () => void, isLoading: boolean, optimisticUpdater: (activity: SetStateAction<IMovieActivity | undefined>) => void] {

	const queryClient = useQueryClient();
	const enabled = Boolean(edi || streamingId);
	const { data, isLoading, refetch } = useUserApiQuery<IMovieActivity>(
		"/api/Movie/MovieActivity",
		{ edi, streamingId },
		{ method: "GET", allowAnon: true },
		{
			enabled,
			refetchOnWindowFocus: false,
			staleTime: 0,
		}
	);


	const optimisticUpdater = useCallback((activity: SetStateAction<IMovieActivity | undefined>) => {
		const queryKey = buildUserApiQueryKey("/api/Movie/MovieActivity", { edi, streamingId })
		let newValue: IMovieActivity | undefined;
		if (typeof activity === "function") {
			const old = queryClient.getQueryData<IMovieActivity>(queryKey);
			newValue = activity(old);
		}
		else {
			newValue = activity;
		}
		queryClient.setQueryData(queryKey, newValue);
	}, [edi, streamingId]);

	const movieActivity = data ?? null;

	return [movieActivity, refetch, isLoading, optimisticUpdater];
}